/**
 * What: Provides one React Polaris layout boundary for resource-index screens.
 * Transport / data-flow: Pure presentation wrapper; callers own data, row models, notices, and URL state.
 */
import { BlockStack, Card } from '@shopify/polaris'
import type { ReactNode } from 'react'

type ShopifyResourceIndexSurfaceProps = {
  children?: ReactNode
  notice?: ReactNode
  loadingState?: ReactNode
  emptyState?: ReactNode
  isLoading?: boolean
  hasData?: boolean
  pagination?: ReactNode
}

/** Keeps index surfaces structurally aligned without changing the app-wide shell. */
export function ShopifyResourceIndexSurface({
  children,
  notice,
  loadingState,
  emptyState,
  isLoading = false,
  hasData = true,
  pagination,
}: ShopifyResourceIndexSurfaceProps) {
  const collectionState = isLoading && !hasData ? loadingState : !isLoading && !hasData ? emptyState : null

  return (
    <BlockStack gap="300" data-testid="shopify-resource-index-surface">
      {notice}
      {collectionState ?? (
        <>
          <Card padding="0">{children}</Card>
          {pagination}
        </>
      )}
    </BlockStack>
  )
}
